import { ReactElement, JSXElementConstructor } from 'react';
import ReactDOMServer from 'react-dom/server';

export default class Export{
  name: string;
  filters: { [x:string]: any; per_page?: number | null; page?: number; };
  f_r?: Function;
  
  constructor(name: string, filters: { [x:string]: any; per_page?: number | null; page?: number; }){
    this.name = name
    this.filters = {...filters, page:1, per_page:null}
  }

  __format_name(){
    let listFilters = [
      "%date","%time","%filters"
    ];

    let run;
    do{
      run = false;
      let filter = "";
      for (let i = 0; i < listFilters.length; i++) {
        const element = listFilters[i];
        if(this.name.indexOf(element) !== -1) {
          run = true;
          filter = element;
          i = listFilters.length;
        }
      }
      if(run){
        let date = new Date()
        let filters = {...this.filters}
        delete filters.page;
        delete filters.per_page;

        switch (filter) {
          case "%date":
            this.name = this.name.replace("%date",`${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`);
            break;
          case "%time":
            let h = date.getHours().toString();
            let m = date.getMinutes().toString();
            let s = date.getSeconds().toString();
            
            this.name = this.name.replace("%time",`${h.length===1?"0"+h:h}${m.length===1?"0"+m:m}${s.length===1?"0"+s:s}`);
            break;
          case "%filters":
            let aux = ""
            Object.keys(filters).forEach(key=>{
              let item = filters[key];
              if(item){
                if(key.substring(0,2) === "__"){
                  if(aux.length>1) aux+= "_";
                  aux += `${key.substring(2,key.length)}_${item}`
                }
              }
            })
            this.name = this.name.replace("%filters",aux);
            break;
          default:
            break;
        }
      }
    }while(run);
  }

  request(f_r: Function){
    this.f_r = f_r;
  }

  async run(){
    let list: any[] = [];
    var next = null;
    if(this.f_r){
      do {
        const {data, pagination}: any = await this.f_r({params:this.filters});
        list = list.concat(data);
        next = pagination.next_page;
        this.filters = {...this.filters, page:next};
      } while (next);
    }

    return list;
  }

  setFilters(filters: { [x: string]: any; per_page: number; page: number; }){
    this.filters = {...this.filters, ...filters, page:1, per_page: 3000};
  }

  exportTable(table: ReactElement<any, string | JSXElementConstructor<any>>){
    function getHTML(table: string, fileName: string){
      return (`
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
        <head>
          <!--[if gte mso 9]>
            <xml>
              <x:ExcelWorkbook>
                  <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                        <x:Name>${fileName || 'Worksheet'}</x:Name>
                        <x:WorksheetOptions>
                          <x:DisplayGridlines/>
                        </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                  </x:ExcelWorksheets>
              </x:ExcelWorkbook>
            </xml>
          <![endif]-->
          <meta name=ProgId content=Excel.Sheet>
          <meta name=Generator content="Microsoft Excel 9">
        </head>
        <body>
          ${table}
        </body>
      </html>`);
    }
    this.__format_name();
    var data_type = 'data:application/vnd.ms-excel; charset=UTF-8';
    var a = document.createElement('a');
  
    var table_html = escape(getHTML(ReactDOMServer.renderToString(table), this.name));
    a.href = data_type + ', ' + table_html;
    a.download = this.name+'.xls';
    a.click();
  }
}